// @flow
import React, { Component, useRef, type ComponentType, type Node } from 'react'
import List from 'react-draggable-list'
import hash from 'object-hash'

type ItemType = any

type Props = {|
  className?: ItemType,
  items: Array<ItemType>,
  onChange: (Array<ItemType>) => void,
  renderItem: (ItemType) => Node,
  padding?: number
|}

type ItemProps = {
  item: ItemType,
  dragHandleProps: Object,
  commonProps: {| renderItem: (ItemType) => Node |}
}

class ItemTemplate extends Component<ItemProps> {
  render() {
    return (
      <div {...this.props.dragHandleProps}>
        {this.props.commonProps.renderItem(this.props.item)}
      </div>
    )
  }
}

const DraggableList: ComponentType<Props> = function DraggableList(props: Props) {
  let wrapperRef = useRef()
  return (
    <div className={props.className} ref={wrapperRef}>
      <List
        list={props.items}
        itemKey={(item) => hash(item)}
        template={ItemTemplate}
        onMoveEnd={(items: any) => props.onChange(items)}
        container={() => wrapperRef.current}
        commonProps={{ renderItem: props.renderItem }}
        padding={props.padding || 0}
      />
    </div>
  )
}

export default DraggableList
